import { createReducer, on } from "@ngrx/store";
import { ModuleConfigurationActions } from "../actions/action-index";
import { ModuleConfiguration } from "./module-configuration";

export const featureKey = "moduleConfiguration";

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface ModuleConfigurationState extends ModuleConfiguration { }

export const initialState: ModuleConfigurationState = {
  modules: [],
  practiceLocationId: 0,
  doctors: [],
};

export const reducer = createReducer(
  initialState,
  on(
    ModuleConfigurationActions.loadSuccess,
    ( state, { moduleConfiguration } ) => ( {
      ...state,
      ...moduleConfiguration
    } )
  )
);
